import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { ChameleonService } from './chameleon.service';
import { Session } from './data/session';

@Injectable()
export class AuthService {
  // isLoggedIn: boolean = false;
  email: string;
  password: string;
  session: Session;
  public didLogout$: EventEmitter<any>;

  constructor(
    private http: HttpClient,
    private chameleonService: ChameleonService
  ) {
    this.didLogout$ = new EventEmitter;
    ['session'].forEach(s => {
      var v = localStorage.getItem(s);
      if (v) {
        this[s] = JSON.parse(v);
      }
    });
  }

  isLoggedIn(): boolean {
    return this.session != null;
  }

  isSessionExpired(): boolean {
    if (!this.session || !this.session.Expiration) return true;
    const expirationDate = new Date(this.session.Expiration);
    if (isNaN(expirationDate.getDate())) return true;
    return expirationDate < new Date();
  }

  isSuper(): boolean {
    return this.session ? this.session.RoleCode === environment.ROLE_SUPER : false;
  }

  isInternal(): boolean {
    return this.session && this.session.Email ? this.session.Email.endsWith("@alegralearning.com") : false;
  }

  isAdmin(): boolean {
    return this.session ? this.isSuper() || this.session.RoleCode === environment.ROLE_ADMIN : false;
  }

  isTeacher(): boolean {
    return this.session ? this.session.RoleCode === environment.ROLE_TEACHER : false;
  }

  isParent(): boolean {
    return this.session ? this.session.SessionType === "Parent" : false;
  }

  getToken(): string {
    return this.session ? this.session.Token : '';
  }

  // loginOld(roleType: string): Observable<boolean> {
  //   // this.loggedIn.next(true);
  //   this.isLoggedIn = true;
  //   this.roleType = roleType;
  //   // tap performs a side effect
  //   return of(true).pipe(
  //     // delay(100),
  //     // tap(val => this.isLoggedIn = false)
  //   );
  // }

  // login(email: string, password: string): Observable<boolean> {
  //   return this.dataService.createAccountSession(email, password).flatMap(session => {
  //     console.log("Login. session: ", session);
  //     if (session != null) {
  //       this.session = session;
  //       localStorage.setItem("session", JSON.stringify(session));
  //       // this.isLoggedIn = true;
  //       this.email = email;
  //       this.password = password;
  //     }
  //     return of(this.isLoggedIn());
  //   });
  //   // return of(true);
  // }

  logout(): void {
    ['session'].forEach(s => {
      this[s] = null;
      localStorage.removeItem(s);
    });
    this.chameleonService.clearChameleonIdentity();
    this.didLogout$.emit();
  }

  setSession(session: Session): void {
    this.session = session;
    localStorage.setItem('session', JSON.stringify(session));
    this.chameleonService.trySetChameleonIdentity();
  }
}
